import { PayrollRunCycleType } from "@wingspanhq/wingspan-api-sdk";

import { UrlQueryFilter } from "../../../../../shared/hooks/useUrlQuery";

/**
 * Sentinel first option of the cycle-type radio, meaning "no filter". Typed as
 * `string` (not the literal) so it compares cleanly against the enum-typed
 * `cycleType` without a no-overlap error.
 */
export const PAYROLLS_CYCLE_FILTER_ALL: string = "All";

export interface PayrollsFilter extends UrlQueryFilter {
  /** On-cycle vs off-cycle; {@link PAYROLLS_CYCLE_FILTER_ALL} means unfiltered. */
  cycleType?: PayrollRunCycleType;
  /**
   * Selected display statuses (the `label`s of
   * `PAYROLL_RUNS_STATUS_FILTER_OPTIONS`), each expanding to one or more
   * `PayrollRunStatus` values — see `selectorPayrollRunsFilterStatuses`.
   */
  status?: string[];
}
